"use client"

import prepareComponent from "@bluframe/grapple/prepareComponent"
import React, {
  ChangeEvent,
  FocusEvent,
  FormEventHandler,
  KeyboardEvent,
  MouseEvent,
  type Ref,
  useState
} from "react"

import InputText from "./InputText"

export interface Props {
  className?: string
  defaultValue?: string
  disabled?: boolean
  error?: boolean
  errorText?: string
  iconEnd?: React.ReactNode
  iconStart?: React.ReactNode
  infoText?: string
  inputId?: string
  inputProps?: {
    "aria-activedescendant"?: string
    "aria-autocomplete"?: "list" | "none" | "inline" | "both"
    "aria-controls"?: string
    "aria-expanded"?: boolean
    "aria-labelledby"?: string
    autoComplete?: string
    id?: string

    onBlur?: (event: FocusEvent) => void

    onChange?: (event: ChangeEvent) => void

    onClick?: (event: MouseEvent) => void
    role?: string
  }
  isFullBorder?: boolean
  label: React.ReactNode
  loading?: boolean
  max?: number
  min?: number

  onBlur?: (event: FocusEvent) => void

  onChange?: (event: ChangeEvent<HTMLInputElement>) => void

  onClick?: (event: MouseEvent) => void

  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  name: string
  ref?: Ref<HTMLInputElement>
  required?: boolean
  size?: number
  step?: string
  success?: boolean
  successText?: string
  type?: string
  value?: string | number
}

export interface ComponentProps extends Props {
  hasContent: boolean
  labelId?: string
  onInput: FormEventHandler<HTMLInputElement>
}

const ZERO = 0

const usePrepareComponent = (props: Props): ComponentProps => {
  const labelId = props.inputId && `${props.inputId}-label`
  const [hasValue, setHasValue] = useState<boolean | null>(null)

  const onBlur = (event: FocusEvent) => {
    if (props.onBlur) {
      props.onBlur(event)
    }

    if (props.inputProps?.onBlur) {
      props.inputProps.onBlur(event)
    }
  }

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(event)
    }

    if (props.inputProps?.onChange) {
      props.inputProps.onChange(event)
    }
  }

  const onInput: FormEventHandler<HTMLInputElement> = (event) => {
    // @ts-expect-error - event target
    setHasValue(event.target.value.length > ZERO)
  }

  const onClick = (event: MouseEvent) => {
    if (props.onClick) {
      props.onClick(event)
    }
    if (props.inputProps?.onClick) {
      props.inputProps.onClick(event)
    }
  }

  const hasContent = Boolean(hasValue ?? props.defaultValue ?? props.value)

  return {
    ...props,
    hasContent,
    labelId,
    onBlur,
    onChange,
    onClick,
    onInput
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  InputText
)
